import PortalIdParser from 'PortalIdParser';
import * as storage from 'reporting-data/lib/storage';
import { ANALYTICS_SUITE_TAB_IDS } from '../SmartLibrary/types/navigation';
const RECENT_TEMPLATES_STORAGE_KEY = 'analyticsSuites:recentlyViewed';
const RECENT_TEMPLATES_LIMIT = 4;
const getRecentlyViewedForAllPortals = () => storage.get(RECENT_TEMPLATES_STORAGE_KEY) || {};
const getRecentlyViewedSubAppKeysForPortal = () => {
  const allRecentStorage = getRecentlyViewedForAllPortals();
  const portalId = PortalIdParser.get();
  return portalId && allRecentStorage[portalId] || {};
};
export const getRecentlyViewedSubAppKeysForHomePage = suiteId => getRecentlyViewedSubAppKeysForPortal()[suiteId] || [];
const getUpdatedTemplateListForHomePage = (newSubAppKey, suiteId) => {
  const templates = getRecentlyViewedSubAppKeysForHomePage(suiteId).filter(key => key !== newSubAppKey);
  templates.unshift(newSubAppKey);
  return templates.slice(0, RECENT_TEMPLATES_LIMIT);
};
export const recordRecentlyViewedTemplate = (subAppKeyKey, collectionId, categoryId) => {
  const newValues = {
    [ANALYTICS_SUITE_TAB_IDS.DISCOVER]: getUpdatedTemplateListForHomePage(subAppKeyKey, ANALYTICS_SUITE_TAB_IDS.DISCOVER),
    [collectionId]: getUpdatedTemplateListForHomePage(subAppKeyKey, collectionId)
  };
  if (categoryId) {
    newValues[categoryId] = getUpdatedTemplateListForHomePage(subAppKeyKey, categoryId);
  }
  const portalId = PortalIdParser.get();
  if (portalId) {
    storage.set(RECENT_TEMPLATES_STORAGE_KEY, Object.assign({}, getRecentlyViewedForAllPortals(), {
      [portalId]: Object.assign({}, getRecentlyViewedSubAppKeysForPortal(), newValues)
    }));
  }
};